import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-sm shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div
          className={`font-serif text-2xl tracking-[0.2em] cursor-pointer font-bold ${
            scrolled ? "text-[#3a4a28]" : "text-white"
          }`}
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          KUU
        </div>

        <nav className="hidden md:flex items-center gap-8">
          {[
            { label: "KUUについて", id: "about" },
            { label: "メニュー", id: "menu" },
            { label: "よくある質問", id: "faq" },
            { label: "アクセス", id: "access" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className={`text-sm tracking-wider transition-colors cursor-pointer whitespace-nowrap ${
                scrolled
                  ? "text-[#3a4a28] hover:text-[#5a7040]"
                  : "text-white/90 hover:text-white"
              }`}
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("reserve")}
            className={`text-sm tracking-wider px-5 py-2 rounded-sm transition-all cursor-pointer whitespace-nowrap ${
              scrolled
                ? "bg-[#3a4a28] text-white hover:bg-[#4a5e35]"
                : "bg-white/20 text-white border border-white/60 hover:bg-white/30"
            }`}
          >
            ご予約
          </button>
        </nav>

        <button
          className={`md:hidden cursor-pointer ${scrolled ? "text-[#3a4a28]" : "text-white"}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-2xl`} />
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white/98 backdrop-blur-sm border-t border-gray-100">
          {[
            { label: "KUUについて", id: "about" },
            { label: "メニュー", id: "menu" },
            { label: "よくある質問", id: "faq" },
            { label: "アクセス", id: "access" },
            { label: "ご予約", id: "reserve" },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="w-full text-left px-6 py-4 text-sm text-[#3a4a28] border-b border-gray-50 hover:bg-gray-50 cursor-pointer tracking-wider"
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
